@if (autenticationType == 'login') {
  <div>
    <h2 class="mt-0" mat-dialog-title>Log into your account</h2>
    @if (loginErrorMessage) {
      <p class="error-message">{{ loginErrorMessage }}</p>
    }
    <mat-dialog-content class="authentication">
      <form [formGroup]="loginForm" (ngSubmit)="login(loginForm.value)">
        <mat-form-field appearance="outline">
          <mat-label>E-mail</mat-label>
          <input matInput placeholder="" name="email" [formControl]="loginForm.controls['email']" required />
          <mat-icon matSuffix>alternate_email</mat-icon>
          <!-- <mat-error *ngIf="email.invalid">{{getErrorMessage()}}</mat-error> -->
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Mot de passe</mat-label>
          <input [type]="hide ? 'password' : 'text'" matInput placeholder="" name="password" [formControl]="loginForm.controls['password']" required />
          <mat-icon matSuffix (click)="hide = !hide">{{ hide ? 'lock' : 'lock_open' }}</mat-icon>
          <!-- <mat-error *ngIf="password.invalid">{{getErrorMessage()}}</mat-error> -->
        </mat-form-field>
        <button class="mb-05" mat-raised-button color="primary" [disabled]="!loginForm.valid && captchaSolved" type="submit">Connect</button>
      </form>
      <div id="recaptcha-container"></div>
      <a (click)="setForgotPass()">Forgot password?</a>
    </mat-dialog-content>
    <mat-dialog-actions align="start">
      <button class="p-0" mat-flat-button (click)="setAutenticationType('signup')">
        Don't have an account?
        <u>Sign up</u>
      </button>
    </mat-dialog-actions>
  </div>
}

@if (autenticationType == 'forgotPass') {
  <div class="card-panel form-container">
    <h3>Forgot your password</h3>
    <p>Enter e-mail address</p>
    <mat-label>E-mail</mat-label>
    <mat-form-field appearance="outline">
      <input matInput placeholder="" [(ngModel)]="forgottenEmail" id="forgot-email" required />
    </mat-form-field>
    <button (click)="sendPassRecInfo()">Reset</button>
    <a (click)="setAutenticationType('login')">Back to login Screen</a>
  </div>
}

@if (autenticationType == 'signup') {
  <div class="card-panel form-container">
    @if (displayTitle) {
      <h2 class="mt-0 mb-1 auth-title" mat-dialog-title>Essayez gratuitement</h2>
    }
    @if (loginErrorMessage) {
      <p class="error-message">{{ loginErrorMessage }}</p>
    }
    <mat-dialog-content class="authentication">
      <form [formGroup]="registerForm" (ngSubmit)="signup(registerForm.value)">
        <mat-form-field appearance="outline">
          <mat-label>Prénom</mat-label>
          <input matInput placeholder="" name="firstName" [formControl]="registerForm.controls['firstName']" required />
          <mat-icon matSuffix>person</mat-icon>
          <!-- <mat-error *ngIf="firstName.invalid">{{getErrorMessage()}}</mat-error> -->
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Nom</mat-label>
          <input matInput placeholder="" name="lastName" [formControl]="registerForm.controls['lastName']" required />
          <mat-icon matSuffix>person</mat-icon>
          <!-- <mat-error *ngIf="lastName.invalid">{{getErrorMessage()}}</mat-error> -->
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>E-mail</mat-label>
          <input matInput placeholder="" name="email" [formControl]="registerForm.controls['email']" required />
          <mat-icon matSuffix>alternate_email</mat-icon>
          <!-- <mat-error *ngIf="email.invalid">{{getErrorMessage()}}</mat-error> -->
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Mot de passe</mat-label>
          <input [type]="hide ? 'password' : 'text'" matInput placeholder="" name="password" [formControl]="registerForm.controls['password']" required />
          <mat-icon matSuffix (click)="hide = !hide">{{ hide ? 'lock' : 'lock_open' }}</mat-icon>
          <!-- <mat-error *ngIf="password.invalid">{{getErrorMessage()}}</mat-error> -->
        </mat-form-field>
        <button class="mb-05" color="accent" mat-lg-button mat-raised-button type="submit" [disabled]="registerForm.invalid">Je m'inscris</button>
      </form>
    </mat-dialog-content>
    <mat-dialog-actions align="start">
      <div class="flex-grow-item"></div>
      @if (showLogin) {
        <button class="p-0" mat-flat-button (click)="setAutenticationType('login')">
          Already have an account?
          <u>Log in</u>
        </button>
      }
    </mat-dialog-actions>
  </div>
}
